import React from 'react';
import './Chats.css';
import Chat from './Chat';

const Chats = () => {
    return (
        <div className='chats'>
            <Chat
                name="Balbasor"
                message="Yo Bro Whatsup"
                timestamp="20 second ago"
                profilePic="https://i.pinimg.com/originals/08/36/49/0836496331b2369df9f27a545d5f250a.jpg"
            />
            <Chat
                name="Squatel 🥇"
                message="Hello Guys"
                timestamp="5 minute ago"
                profilePic="https://i.pinimg.com/originals/b2/01/18/b201181cd337130bbec6d9f9f00a2932.png"
            />
            <Chat
                name="Pikachu 🤟"
                message="Whats going on "
                timestamp="2 hour ago"
                profilePic="https://i.pinimg.com/originals/76/47/9d/76479dd91dc55c2768ddccfc30a4fbf5.png"
            />
            <Chat
                name="Charmendar 🔥"
                message="Yup"
                timestamp="1 day ago"
                profilePic="https://i.pinimg.com/originals/7a/f6/0b/7af60b2b6fa202db54f0aa275fee6e17.png"
            />
        </div>
    )
}

export default Chats;
